export const formatSalary = (value, currency) => {
  if (value === null || value === undefined || value === "") return "";

  const amount = Number(value);
  if (isNaN(amount)) return "";

  const formatted = amount.toLocaleString("en-IN");

  return currency ? `${currency} ${formatted}` : formatted;
};
